import {IGenericObject} from '../Types/IGenericObject';
import {IDepotInfo} from '../Types/IDepot';

const SupplierNameMap: IGenericObject = {
    "AV": "Avis",
    "BG": "Budget",
    "BC": "Bargain Car Rentals",
    "TH": "Thrifty",
    "EC": "Europcar",
    "EF": "Everything Fleet",
    "HZ": "Hertz",
    "RS": "Redspot",
    "AC": "Atlas Choice",
    "AE": "Auto Europe",
    "AL": "Alamo",
    "EN": "Enterprise",
    "GM": "Green Motion",
    "HA": "Holiday Autos",
    "SX": "Sixt",
    "TE": "Thrifty",
    "AD": "Advantage",
    "DO": "Dollar",
    "EZ": "E-Z",
    "FX": "Fox",
    "NA": "National",
    "NB": "No Birds",
    "PL": "Payless",
    "TU": "Thrifty",
    "HD": "Dollar",
    "HT": "Thrifty",
    "TN": "Thrifty",
    "FF": "Firefly",
    "ER": "East Coast",
    "GO": "Go Rentals",
    "AO": "Aerodrive"
}

export const getSupplierName = (supplierCode: string): string => {
    if (SupplierNameMap.hasOwnProperty(supplierCode)) {
        return SupplierNameMap[supplierCode];
    }

    return supplierCode;
}

export const getAvailableSuppliersFromDepots = (depots: IDepotInfo[]): string[] => {
    const supplierMap = {};

    depots.forEach((depot: IDepotInfo) => {
        if (typeof supplierMap[depot.supplier_code] === 'undefined') {
            supplierMap[depot.supplier_code] = depot.supplier_code;
        }
    });

    return Object.keys(supplierMap)
        .map((code: string) => code);
}
